import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { handleSpringDataRequest } from "../../api";
import { useSelector } from "react-redux";
import { toast } from "material-react-toastify";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  Menu,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BookingDataLoader from "./BookingDataLoader";
import Freeze from "../../Utils/Freeze";
import i18n from "../../modules/Auth/pages/i18n";
import store from "../../../redux/store";
import { format } from "date-fns";
import BookingDataLoader2 from "./BookingDataLoader2";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import Header from "./Header";
import { openJoinStayflexiFromPms } from "../../Utils/openJoinStayflexiFromPms";

const BookingDashboard2 = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const { freezed } = props;
  const [raised, setRaised] = useState({});
  const [bookingData, setBookingData] = useState(props.bookingData);
  const [searchTerm, setsearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(Boolean(anchorEl));
  const [multiOption, setMultiOption] = useState("");
  const [openBillingModal, setopenBillingModal] = useState(false);
  const [openBrandingModal, setopenBrandingModal] = useState(false);
  const [openCTASModal, setopenCTASModal] = useState(false);
  const hotelId = localStorage.getItem("hotelId");
  const [env, setEnv] = useState(process.env.REACT_APP_ENV);
  const [userRole, setUserRole] = useState("");
  const [addHotel, setaddHotel] = useState("");
  const [copyHotelId, setcopyHotelId] = useState("");
  const [goToDashboardLoading, setGoToDashboardLoading] = useState(false);
  const [selectedHotelId, setSelectedHotelId] = useState("");

  const getUserRole = () => {
    handleSpringDataRequest(
      `core/api/v1/groupaccess/getUserRole?userEmail=${email}`
    )
      .then((res) => {
        setUserRole(res);
      })
      .catch((err) => {
        console.log("the err is : ", err);
      });
  };

  useEffect(() => {
    getUserRole();
  }, []);

  const toggleRaised = (num) => {
    raised[num] = !raised[num];
    setRaised({ ...raised });
  };

  const openTheBillingModal = (num) => {
    setopenBillingModal(true);
  };

  const hideTheBillingModal = () => {
    setopenBillingModal(false);
  };

  const openTheBrandingModal = () => {
    setopenBrandingModal(true);
  };

  const hideTheBrandingModal = () => {
    setopenBrandingModal(false);
  };

  const openTheCTAModal = () => {
    setopenCTASModal(true);
  };

  const hideTheCTAModal = () => {
    setopenCTASModal(false);
  };

  // quick search
  const onFilterTextChange = (event) => {
    setsearchTerm(event.target.value);
  };
  const [hotelIds, sethotelIds] = useState(null);
  const [groupId, setgroupId] = useState(null);
  useEffect(() => {
    // getAllData();
  }, []);
  const [loader, setloader] = useState(false);
  const [hotelData, sethotelData] = useState([]);
  const auth = useSelector((state) => state.auth);
  const email = auth.email;
  console.log("abhishek redux state: ", store.getState());
  useEffect(() => {
    if (bookingData) {
      const data = bookingData.filter(function (el) {
        if (hotelStatus !== "All") return el.status === hotelStatus;
        else return el.status;
      });

      return sethotelData(data);
    }
  }, [bookingData]);

  const [hotelStatus, sethotelStatus] = useState("ACTIVE");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChanges = (val) => {
    const data = bookingData.filter(function (el) {
      if (val !== "All") return el.status === val;
      else return el.status;
    });
    sethotelData(data);
    sethotelStatus(val);
  };

  const [accountInfo, setAccountInfo] = useState(null);
  const getCompanyData = (actId) => {
    handleSpringDataRequest(
      `core/api/v1/account/get-single/?groupId=${actId}&hotelId=${actId}`
    )
      .then((res) => {
        setAccountInfo(res);
      })
      .catch((err) => {
        console.log("the err is : ", err);
      });
  };

  useEffect(() => {
    // groupId && getCompanyData();
  }, [groupId]);

  const getActualGroupId = () => {
    handleSpringDataRequest(
      `core/api/v1/account/get-accountId/?newId=${groupId}`
    )
      .then((res) => {
        setgroupId(res);
        if (res !== "") getCompanyData(res);
      })
      .catch((err) => {
        console.log("the err is : ", err);
      });
  };

  useEffect(() => {
    groupId && getActualGroupId();
  }, [groupId]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [copyLoader, setcopyLoader] = useState(false);

  const copyProperty = () => {
    if (copyHotelId === "") {
      toast.error(`${t("Please select hotel")}`);
      return;
    }
    setcopyLoader(true);
    handleSpringDataRequest(
      `common/copy-hotel?emailId=${localStorage.getItem(
        "groupEmail"
      )}&newId=${copyHotelId}`
    )
      .then((res) => {
        {
          toast.success(
            `${t(
              "Successfully copied the hotel It will take some time around"
            )} 15-20 seconds.`
          );
          props.getAllData();
          handleClose();
          setaddHotel("");
          setcopyLoader(false);
        }
      })
      .catch((err) => {
        toast.error(`${t("Something went wrong")}`);
        setcopyLoader(false);
      });
  };

  const [isMasterUser, setisMasterUser] = useState(false);

  useEffect(() => {
    localStorage.getItem("rootEmail") !== null &&
      localStorage.getItem("rootEmail") !== undefined &&
      handleSpringDataRequest(
        `user/check-master-user?email=${localStorage.getItem(
          "rootEmail"
        )}&hotelId=${localStorage.getItem(
          "mainGroupId"
        )}&hotel_id=${localStorage.getItem("mainGroupId")}`
      )
        .then((res) => setisMasterUser(res))
        .catch((err) => console.error(`${t("Please try again later")}.`));
  }, [localStorage.getItem("rootEmail")]);

  useEffect(() => {
    if (hotelData?.length > 0) {
      hotelData.sort((a, b) => {
        // Convert hotelIds to numbers for numerical comparison
        const idA = parseInt(a.hotelId);
        const idB = parseInt(b.hotelId);

        // Compare hotelIds in descending order
        return idB - idA;
      });
    }
  }, [hotelData]);

  const storeToken = (hotelId) => {
    setGoToDashboardLoading(true);
    setSelectedHotelId(hotelId);
    fetch(
      `${process.env.REACT_APP_SPRING_API_URL}common/persist-user-token?hotelId=${hotelId}&email=${auth?.email}`,
      {
        method: "GET", // or 'POST' if the endpoint expects a POST request
        headers: {
          Token: localStorage.getItem("token"),
        },
      }
    )
      .then((data) => {
        window.open(`/dashboard?hotelId=${hotelId}`, "_blank");
      })
      .catch((error) => console.error("Error persist-user-token:", error))
      .finally(() => setGoToDashboardLoading(false));
  };
  const imageLastModifiedDateTime = useMemo(
    () => format(new Date(), "ddMMyyyyhhmmsstt"),
    []
  );

  const [addPropertyMenuAnchorEl, setAddPropertyMenuAnchorEl] = useState(null);

  const handleAddPropertyClick = (event) =>
    setAddPropertyMenuAnchorEl(event.currentTarget);
  const handleAddPropertyClose = () => setAddPropertyMenuAnchorEl(null);

  const handleAddNewListing = () => {
    handleAddPropertyClose();
    // your logic for add listing
    openJoinStayflexiFromPms({
      email: auth.email,
      token: auth.token || localStorage.getItem("token"),
    });
  };

  const handleCopyProperty = () => {
    handleAddPropertyClose();
    // your logic for copy property
    console.log("Copy property selected");
  };
  return (
    <Box sx={{ height: "100%" }}>
      <Modal
        open={freezed === "YES"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Freeze />
      </Modal>

      <Grid container spacing={2} maxHeight={"100%"}>
        {/* HOTEL FILTER AND CREATORS  */}

        <Grid
          item
          container
          xs={12}
          sx={{ borderRadius: "1rem" }}
          rowSpacing={2}
          columnSpacing={2}
        >
          <Grid item sx={{ pl: "16px" }} xs={12}>
            <Header title={"Welcome to your group dashboard"} mode="light" />
          </Grid>
          <Grid item xs={12} md={8}>
            <OutlinedInput
              onChange={onFilterTextChange}
              placeholder={`${t("Search properties...")}`}
              label={`${t("Search properties")}`}
              notched={false}
              fullWidth
              type="search"
              size="small"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              style={{
                borderRadius: "8px",
                backgroundColor: "white",
              }}
            />
          </Grid>

          {/* HOTEL STATUS FILTER  */}
          <Grid item xs={6} md={2}>
            <FormControl
              fullWidth
              sx={{
                boxShadow: "0px 0px 16px 6px #0000001a",
                borderRadius: "5px",
                backgroundColor: "white",
              }}
              size="small"
            >
              <InputLabel>{`${t("Hotel Status")}`}</InputLabel>
              <Select
                value={hotelStatus}
                onChange={(e) => handleChanges(e.target.value)}
                MenuProps={MenuProps}
                label={`${t("Hotel Status")}`}
              >
                <MenuItem value={"All"}>{`${t("All")}`}</MenuItem>
                <MenuItem value={"ACTIVE"}>{`${t("Active")}`}</MenuItem>
                <MenuItem value={"INACTIVE"}>{`${t("Inactive")}`}</MenuItem>
                <MenuItem value={"TRIAL"}>{`${t("Trial")}`}</MenuItem>
                <MenuItem value={"INQUIRY"}>{`${t("Enquiry")}`}</MenuItem>
                <MenuItem value={"ONBOARDING PENDING"}>
                  {`${t("Onboarding pending")}`}
                </MenuItem>
                <MenuItem value={"TEST"}> {`${t("Test")}`}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* HOTEL LISTING CREATOR  */}
          <Grid item xs={6} md={2}>
            {!isMasterUser &&
              userRole === "ADMIN" &&
              props.groupBrandingData.status !== "ENABLED" && (
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() =>
                    openJoinStayflexiFromPms({
                      email: auth.email,
                      token: auth.token || localStorage.getItem("token"),
                    })
                  }
                  startIcon={<AddIcon />}
                  sx={{
                    backgroundColor: "#000",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "10px",
                    fontWeight: 600,
                    flex: 1,
                    px: 2.5,
                    py: 1,
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Add Property
                </Button>
              )}
            {isMasterUser &&
              userRole === "ADMIN" &&
              props.groupBrandingData.status !== "ENABLED" && (
                // <FormControl
                //   fullWidth
                //   size="small"
                //   sx={{
                //     width: "10%",
                //     marginLeft: "3%",
                //     boxShadow: "0px 0px 16px 6px #0000001a",
                //     borderRadius: "5px",
                //     backgroundColor: "white",
                //   }}
                // >

                //   <InputLabel>{`${t("Add property")}`}</InputLabel>
                //   <Select
                //     labelId="demo-simple-select-label"
                //     id="demo-simple-select"
                //     onChange={(e) => {
                //       if (e.target.value === "ADD-LISTING") {
                //         window.open(`https://join.stayflexi.com/`, "_blank");
                //         setaddHotel("");
                //       } else {
                //         handleShow();
                //         setaddHotel("");
                //       }
                //     }}
                //     label={`${t("Add property")}`}
                //     size="small"
                //     value={addHotel}
                //   >
                //     <MenuItem
                //       disabled={freezed === "YES"}
                //       value={"ADD-LISTING"}
                //     >
                //       {`${t("Add listing")}`}
                //     </MenuItem>
                //     {isMasterUser && (
                //       <MenuItem
                //         disabled={freezed === "YES"}
                //         value={"COPY-HOTEL"}
                //       >
                //         {`${t("Copy property")}`}
                //       </MenuItem>
                //     )}
                //   </Select>
                // </FormControl>

                <>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleAddPropertyClick}
                    startIcon={<AddIcon />}
                    sx={{
                      backgroundColor: "#000",
                      color: "#fff",
                      textTransform: "none",
                      borderRadius: "10px",
                      fontWeight: 600,
                      flex: 1,
                      px: 2.5,
                      py: 1,
                      "&:hover": {
                        backgroundColor: "#333",
                      },
                    }}
                  >
                    Add Property
                  </Button>
                  <Menu
                    anchorEl={addPropertyMenuAnchorEl}
                    open={!!addPropertyMenuAnchorEl}
                    onClose={handleAddPropertyClose}
                  >
                    <MenuItem onClick={handleAddNewListing}>
                      <ListItemIcon>
                        <NoteAddIcon fontSize="small" />
                      </ListItemIcon>
                      <Typography variant="inherit">Add Listing</Typography>
                    </MenuItem>
                    <MenuItem onClick={handleCopyProperty}>
                      <ListItemIcon>
                        <FileCopyIcon fontSize="small" />
                      </ListItemIcon>
                      <Typography variant="inherit">Copy Property</Typography>
                    </MenuItem>
                  </Menu>
                </>
              )}
          </Grid>
        </Grid>

        {/* HOTEL COUNT  */}
        <Grid item xs={12}>
          <h3
            className="text-muted"
            // style={{ marginLeft: "9.5rem", marginBottom: "0px" }}
          >
            {`${t("Showing")} `} {hotelData?.length} {` ${t("properties")}`}
          </h3>
        </Grid>
        {!loader ? (
          <Grid
            item
            container
            spacing={2}
            sx={{
              maxHeight: `calc(100% - 64px)`,
              overflow: "auto",
              pb: 4,
              mt: 0,
              display: "flex",
              flexWrap: "wrap",
            }}
            xs={12}
          >
            {hotelData ? (
              hotelData
                ?.filter((val) => {
                  if (searchTerm == "") {
                    return val;
                  } else if (
                    val.hotelName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val;
                  } else if (
                    val.hotelId.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return val;
                  }
                })
                ?.sort((a, b) => b.hotelId - a.hotelId)
                ?.map((num, index) => {
                  return (
                    <Grid key={num?.hotelId} item sx={{ flexShrink: 0 }}>
                      <div>
                        <Card
                          sx={{
                            borderRadius: "1rem",
                            width: "280px",
                            height: "280px",
                            display: "flex",
                            flexDirection: "column", // Stack vertically
                            overflow: "hidden",
                          }}
                        >
                          <CardActionArea
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "stretch",
                              "&:hover": {
                                cursor: "default",
                              },
                            }}
                          >
                            <Box position="relative" sx={{ flex: 1 }}>
                              <CardMedia
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  // backgroundPosition: "center",
                                  // backgroundSize: "contain",
                                  objectFit: "cover",
                                }}
                                image={`${num?.hotelLogoUrl}?lastmod=${imageLastModifiedDateTime}`}
                                title="Hotel"
                              />
                              <Chip
                                label={num.status}
                                variant="filled"
                                size="small"
                                color="primary"
                                sx={{
                                  position: "absolute",
                                  top: "16px",
                                  right: "16px",
                                  fontWeight: 600,
                                }}
                              />
                            </Box>

                            <CardContent>
                              <Stack spacing={1}>
                                <Typography
                                  variant="h3"
                                  sx={{
                                    fontSize: "18px",
                                    fontWeight: 700,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {num?.hotelName}{" "}
                                </Typography>
                                <Typography
                                  style={{
                                    fontWeight: "lighter",
                                    fontSize: "1rem",
                                  }}
                                >
                                  ( {num?.hotelId} )
                                </Typography>

                                <Typography
                                  sx={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                  }}
                                  component={"p"}
                                  className="text-muted"
                                  ellp
                                >
                                  {num?.address}
                                </Typography>
                                {[
                                  "INQUIRY",
                                  "TEST",
                                  "ACTIVE",
                                  "TRIAL",
                                ].includes(num?.status) && (
                                  <Button
                                    variant="outlined-clean"
                                    disabled={freezed === "YES"}
                                    onClick={() => storeToken(num?.hotelId)}
                                  >
                                    {goToDashboardLoading &&
                                    selectedHotelId === num?.hotelId
                                      ? t("Loading") + "..."
                                      : `${t("Go to dashboard")} `}
                                  </Button>
                                )}
                              </Stack>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </div>

                      <Modal
                        open={show}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box className="foliosConfirmationModal">
                          <div className="folioConfirmationWrapper">
                            <div className="folioConfContent">
                              <CloseIcon
                                style={{
                                  float: "right",
                                  cursor: "pointer",
                                  marginBottom: "2rem",
                                }}
                                onClick={handleClose}
                              />
                              <h4 style={{ textAlign: "left" }}>
                                {`${t(
                                  "Copy property to onboard a new property"
                                )}`}
                              </h4>
                            </div>
                            <Divider />
                            <div>
                              <h4
                                style={{
                                  textAlign: "left",
                                  marginTop: "1rem",
                                }}
                              >
                                {`${t(
                                  "Select from the existing property which you want to copy"
                                )}?`}
                              </h4>
                              <FormControl
                                size="small"
                                fullWidth
                                style={{ marginTop: "1rem" }}
                              >
                                <InputLabel>{`${t(
                                  "Property name"
                                )}`}</InputLabel>
                                <Select
                                  value={copyHotelId}
                                  onChange={(e) =>
                                    setcopyHotelId(e.target.value)
                                  }
                                  MenuProps={MenuProps}
                                  label={`${t("Property name")}`}
                                >
                                  {hotelData
                                    .filter((item) => item.status === "ACTIVE")
                                    .map((item) => (
                                      <MenuItem
                                        value={item.hotelId}
                                      >{`${item.hotelName} - ${item.hotelId}`}</MenuItem>
                                    ))}
                                </Select>
                              </FormControl>

                              <Button
                                variant="custom-button"
                                disabled={copyLoader}
                                onClick={copyProperty}
                                style={{ float: "right", marginTop: "2rem" }}
                              >
                                {copyLoader ? (
                                  <CircularProgress
                                    size={15}
                                    color="inherit"
                                    sx={{ ml: 1.5 }}
                                  />
                                ) : (
                                  `${t("Copy property")}`
                                )}
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Modal>
                    </Grid>
                  );
                })
            ) : (
              <Grid item xs={12}>
                <BookingDataLoader2 />
              </Grid>
            )}
          </Grid>
        ) : (
          <Grid item xs={12}>
            <BookingDataLoader2 />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default BookingDashboard2;
